import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getCategories = (lightweight = false) => {
  return new Promise((resolve, reject) => {
    let url = process.env.REACT_APP_APIUrl + NetworkConfiguration.GET_ALL_FC;
    if (lightweight) url += "?lightweight=1";

    callAPI(
      url,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getCategoryById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.GET_FC_BY_ID +
      `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const FCApiService = {
  getCategories,
  getCategoryById,
};
